import { KineticLines } from "../components/KineticLines";
import { Reveal } from "../components/Reveal";
import { MemberCard } from "../components/MemberCard";
import { WhatsAppCTA } from "../components/WhatsAppCTA";
import { useSiteContent } from "../hooks/useSiteContent";

export default function Membri() {
  const { members, loading } = useSiteContent();

  return (
    <section data-testid="membri-page" className="mx-auto max-w-[1400px] px-5 pb-24 pt-28 md:px-10 md:pt-40 md:pb-32">
      <Reveal y={12}>
        <div className="mb-8 flex items-center gap-3">
          <span className="h-2.5 w-2.5 bg-orange" aria-hidden="true" />
          <span className="font-oswald text-xs uppercase tracking-[0.3em] text-navy md:text-sm">I membri</span>
        </div>
      </Reveal>
      <KineticLines
        lines={["Le persone", <span key="p" className="text-orange">prima di tutto.</span>]}
        className="font-oswald text-[clamp(2.8rem,8vw,7rem)] font-semibold uppercase leading-[0.95] tracking-tight"
      />
      <Reveal delay={0.4} className="mt-8 max-w-xl">
        <p className="text-base leading-relaxed opacity-80">
          Direttivo e collaboratori: dietro ogni iniziativa ci sono volti, storie e competenze.
          Ecco chi porta avanti Progetto Città ogni giorno, tra Trapani ed Erice.
        </p>
      </Reveal>

      {loading ? (
        <p data-testid="members-loading" className="mt-16 font-oswald text-sm uppercase tracking-[0.25em] opacity-60">
          Caricamento…
        </p>
      ) : (
        <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {members.map((m, i) => (
            <MemberCard key={i} member={m} index={i} />
          ))}

          <Reveal delay={members.length * 0.06}>
            <div data-testid="join-card" className="flex h-full min-h-[320px] flex-col justify-between border border-ink bg-navy p-8 text-bone md:p-10">
              <div>
                <span className="h-2.5 w-2.5 bg-orange block" aria-hidden="true" />
                <h3 className="mt-6 font-oswald text-3xl font-semibold uppercase leading-tight tracking-tight">
                  Il prossimo volto potrebbe essere <span className="text-orange">il tuo.</span>
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-bone/75">
                  Hai tempo, idee o semplicemente voglia di fare? Il movimento cresce con chi si mette in gioco.
                </p>
              </div>
              <div className="mt-8">
                <WhatsAppCTA
                  testId="join-whatsapp-button"
                  label="Unisciti a noi"
                  message="Ciao! Vorrei unirmi al movimento Progetto Città: come posso fare?"
                />
              </div>
            </div>
          </Reveal>
        </div>
      )}
    </section>
  );
}
